var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.9956C8 20.9956 15.5 15.6016 15.5 8.10162C15.5 3.97634 12.1533 0.601624 8 0.601624C3.84673 0.601624 0.5 3.94835 0.5 8.10162C0.5 15.6299 8 20.9956 8 20.9956ZM8 5.04335C9.49977 5.04335 10.7111 6.25466 10.7111 7.75443C10.7111 9.2542 9.49977 10.4655 8 10.4655C6.50023 10.4655 5.28892 9.2542 5.28892 7.75443C5.28892 6.25466 6.50023 5.04335 8 5.04335Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.709388a67e3576163cc39f0a29c9505e.svg";
export { ForwardRef as ReactComponent };